// Operation — Top installateurs par nombre de dossiers (bars horizontales).
import { Hammer, Loader2 } from "lucide-react";
import { useOperationFetch } from "./useOperationFetch";

const COLORS = ["var(--oh-stat-blue-text)", "#10b981", "#8b5cf6", "var(--oh-stat-amber-text)", "var(--oh-stat-cyan-text)", "#ec4899", "#14b8a6", "var(--oh-stat-red-text)"];

export default function OperationInstallateursWidget() {
  const { data, loading } = useOperationFetch();
  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;

  const items = data?.par_installateur || [];
  const maxC = Math.max(...items.map(x => x.count || 0), 1);

  return (
    <div className="rounded-xl p-5" style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="operation-installateurs-widget">
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <Hammer className="w-4 h-4 text-cyan-500" />
        Installateurs ({items.length})
      </h3>
      <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
        {items.map((inst, i) => {
          const pct = maxC > 0 ? (inst.count / maxC) * 100 : 0;
          return (
            <div key={inst.installateur} className="flex items-center gap-2 text-xs">
              <span className="w-32 truncate text-right" style={{ color: "var(--oh-text-secondary)" }}>{inst.installateur}</span>
              <div className="flex-1 h-5 rounded-full overflow-hidden" style={{ background: "var(--oh-bg-surface)" }}>
                <div className="h-full rounded-full transition-all"
                  style={{ width: `${pct}%`, backgroundColor: COLORS[i % COLORS.length] }} />
              </div>
              <span className="w-8 text-right font-mono font-bold" style={{ color: "var(--oh-text)" }}>{inst.count}</span>
            </div>
          );
        })}
        {items.length === 0 && (
          <div className="text-center py-6 text-xs" style={{ color: "var(--oh-text-muted)" }}>Aucun installateur</div>
        )}
      </div>
    </div>
  );
}
